import { api } from '../api';

const getFleetCodes = async (data) => {
  const response = await api({
    url: `Vehicles/getFleetCodes`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: data,
  });
  return response.data;
};

const fleetCodeExcelUpload = async (data) => {
  const response = await api({
    url: `Vehicles/fleetCodeExcelUpload`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
  return response.data;
};

const fleetListServices = {
  getFleetCodes,
  fleetCodeExcelUpload,
};

export default fleetListServices;
